import filters from '@/utils/filter'

const helper = {
    goPage(name) {
        return this.vue.$router.push(name)
    },
    accessTo(controller, route) {
        const admin = this.vue.$store.state.stores.admin
        if (!admin) {
            return false
        }
        if (route instanceof Array) {
            let result = false
            for (let i = 0; i < route.length; i++) {
                if (admin.routes.includes(controller + '@' + route[i])) {
                    return true
                }
            }
            return result
        }
        return admin.routes.includes(controller + '@' +route)
    },
    buildDateRangeParams(json, key) {
        if (json[key] && json[key].length > 0) {
            let startedAt = json[key][0]
            let finishedAt = json[key][1]
            json[arguments[2] || 'started_at'] = this.dayFormat(startedAt)
            json[arguments[3] || 'finished_at'] = this.dayFormat(finishedAt)
            delete json[key]
        }
    },
    dayFormat(date) {
        return typeof date === 'string' ? date : date.format('YYYY-MM-DD')
    },
    emptyFormat(record) {
        let text = record
        if (typeof record === 'object') {
            switch (true) {
                case typeof record.cellValue !== 'undefined':
                    text = record.cellValue
                    break
                case typeof record.text !== 'undefined':
                    text = record.text
                    break
            }
        }
        return (text === null
            || text === ''
            || typeof text === 'undefined')
            ? '-' : text
    },
    setDefaultValue(variable, params) {
        let result = {}
        for (let key in params) {
            if (variable && typeof variable[key] !== 'undefined') {
                result[key] = variable[key]
                continue
            }
            result[key] = params[key]
        }
        return variable ? Object.assign({}, variable) : result
    },
    initModel(model, params) {
        const tmpModel = Object.assign({}, model)
        for (let key in params) {
            if ((model && typeof model[key] === 'undefined') || model[key] === null) {
                tmpModel[key] = params[key]
            }
        }
        return tmpModel
    },
    getItemName(items, id) {
        const field = arguments[2] || 'id'
        const name = arguments[3] || 'name'
        let result = []
        id = id instanceof Array ? id : [id]
        for (let key in items) {
            const item = items[key]
            if (!id.includes(item[field])) {
                continue
            }
            result.push(item[`${name}`])
        }
        return result.join(',')
    },
    getPlatforms() {
        return {
            xiaomi: '小米',
            huawei: '华为',
            oppo: 'OPPO',
            vivo: 'VIVO',
        }
    },
    getPlatform(key) {
        return this.getPlatforms()[key]
    },
    ucFirst(str) {
        return str.replace(/( |^)[a-z]/g,(L)=>L.toUpperCase())
    },
    toCamel(str) {
        str = str.replace(/([^_])(?:_+([^_]))/g, function ($0, $1, $2) {
            return ($1 + $2.toUpperCase());
        })
        return this.ucFirst(str)
    },
    commaToArray(str) {
        if (typeof str !== 'string' || str === '') {
            return []
        }
        return str.replace(/，/g, ',').split(',')
    },
    arrayToComma(arr) {
        if (!(arr instanceof Array) || arr.length === 0) {
            return ''
        }
        return arr.join(',')
    },
    clipboard(text) {
        var copy = function (e) {
            e.preventDefault();
            if (e.clipboardData) {
                e.clipboardData.setData('text/plain', text);
            } else if (window.clipboardData) {
                window.clipboardData.setData('Text', text);
            }
        }
        window.addEventListener('copy', copy);
        document.execCommand('copy');
        window.removeEventListener('copy', copy);
    },
    url(prefix, query) {
        const protocol = location.protocol
        let host = location.host.replace(protocol + '//', '')
        const segments = host.split('.dstr.')
        host = segments[segments.length - 1]
        prefix = prefix ? prefix + '' : ''
        query = query || ''
        return `${protocol}//${prefix}.${host}/${query}`
    },
    isPlatform(platform) {
        return localStorage.getItem('platform') === platform
    },
    getMediaKey(media) {
        switch (media) {
            case 1:
                return 'kuaishou'
            case 2:
                return 'juliang'
            case 3:
                return 'baidu'
            case 4:
                return 'vivo'
            case 5:
                return 'tencent'
        }
        return ''
    },
    getMediaId(key) {
        switch (key) {
            case 'kuaishou':
                return 1
            case 'juliang':
                return 2
            case 'baidu':
                return 3
            case 'vivo':
                return 4
        }
        return ''
    },
    getGroupColumn(idx, item = [], fixed = true) {
        switch (idx) {
            case 'media':
                return {
                    title: '媒体',
                    dataIndex: 'media',
                    align: 'center',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: MediaId => {
                        return this.getItemName(item, MediaId) || '-'
                    }
                }
            case 'video_id':
                return {
                    title: '短剧',
                    dataIndex: 'video_id',
                    width: 250,
                    align: 'center',
                    ellipsis: true,
                    fixed: fixed,
                    customRender: function (text, record) {
                        return record.video_name
                    }
                }
            case 'pt_id':
                return { title: '推广ID', dataIndex: 'pt_id', width: 80, align: 'center', fixed: fixed }
            case 'worker_id':
                return {
                    title: '优化师',
                    align: 'center',
                    dataIndex: 'worker_id',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: workerId => {
                        return this.getItemName(item, workerId) || '-'
                    }
                }
            case 'platform_id':
                return {
                    title: '平台',
                    align: 'center',
                    dataIndex: 'platform_id',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: platformId => {
                        return this.getItemName(item, platformId) || '-'
                    }
                }
            case 'channel_id':
                return {
                    title: '渠道',
                    align: 'center',
                    dataIndex: 'channel_id',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: channelId => {
                        return this.getItemName(item, channelId) || '-'
                    },
                }
            case 'team_id':
                return {
                    title: '小组',
                    align: 'center',
                    dataIndex: 'team_id',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: TeamId => {
                        return this.getItemName(item, TeamId) || '-'
                    }
                }
            case 'platform_type':
                return {
                    title: '平台类型',
                    align: 'center',
                    dataIndex: 'platform_type',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: PlatformType => {
                        return this.getItemName(item, PlatformType) || '-'
                    }
                }
            case 'media_corporation':
                return {
                    title: '媒体主体',
                    align: 'center',
                    dataIndex: 'media_corporation',
                    width: 80,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: mediaCorporation => {
                        return mediaCorporation || '-'
                    }
                }
            case 'corporation_id':
                return {
                    title: '主体',
                    align: 'center',
                    dataIndex: 'corporation_id',
                    width: 120,
                    fixed: fixed,
                    ellipsis: true,
                    customRender: corporationId => {
                        return this.getItemName(item, corporationId) || '-'
                    }
                }
            default:
                return {}
        }
    },
    getSummaryValue(summary, item) {
        if (typeof summary[item.field] !== 'undefined') {
            const field = item.field
            let formatter = item.formatter
            formatter = formatter === 'roi' ? 'percent' : formatter
            if (formatter === 'empty') {
                return this.emptyFormat(summary[field])
            }
            return formatter ? filters[formatter](summary[field]) : summary[field]
        } else {
            return '-'
        }
    },
    getFooterData(stats, columns, id) {
        let result = []
        // let cache = localStorage.getItem('VXE_TABLE_CUSTOM_COLUMN_VISIBLE')
        let cache = localStorage.getItem('VXE_CUSTOM_STORE')
    
        let hiddens = []
        if (cache) {
            cache = JSON.parse(cache)[id] || ''
            // console.log('cache', cache)
            if (cache.visibleData) {
                hiddens = Object.keys(cache.visibleData);
            }
            // hiddens = cache.split(',')
        }
        for (const key in stats) {
            const summary = stats[key]
            let row = []
            for (let i = 0; i < columns.length; i++) {
                if (i === 0) {
                    row.push('合计')
                    continue
                }
                const item = columns[i]
                if (item.field && hiddens.includes(item.field)) {
                    continue
                }
                if (item.children && item.children.length > 0) {
                    for (let j = 0; j < item.children.length; j++) {
                        const child = item.children[j]
                        if (child.field && hiddens.includes(child.field)) {
                            continue
                        }
                        row.push(this.getSummaryValue(summary, child))
                    }
                    continue
                }
                row.push(this.getSummaryValue(summary, item))
            }
            result.push(row)
        }
        return result
    },
    tableGrid(id) {
        return {
            id: id,
            loading: false,
            border: true,
            resizable: true,
            showOverflow: true,
            showHeaderOverflow: true,
            showFooterOverflow: true,
            scrollX: { enabled: true },
            height: 'auto',
            size: 'small',
            align: 'center',
            stripe: true,
            pagerConfig: {
                currentPage: 1,
                total: 0,
                pageSize: 20,
                pageSizes: [10, 20, 30, 40, 60, 80, 100],
                layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total'],
            },
            columns: [],
            data: [],
            showFooter: true,
            footerMethod: () => { return [] },
            sortConfig: {
                remote: true,
            },
            toolbarConfig: {
                perfect: true,
                zoom: true,
                custom: true,
                slots: {
                    buttons: 'toolbar_buttons'
                }
            },
            customConfig: {
                storage: {
                    visible: true,
                    resizable: true,
                    sort: true,
                    fixed: true,
                }
            }
        }
    },
    deepClone(object) {
        return JSON.parse(JSON.stringify(object))
    },
    getOrderTypeName(type) {
        let name = '非虚拟支付'
        if (type == 1) {
            name = '虚拟支付'
        } else if (type == 3) {
            name = '抖小'
        } 
        return name
    },
}

export default helper